// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { _ } from "~/i18n";

export default class TakeDate extends Content {
	_build() {
		this._dom.container.classList.add("content-takedate");
		if(this._data.length) {
			this._dom.container.innerHTML = "<em>" + _("detail.content.takeDate") + ": </em>" + this._data[2] + ". " + this._data[1] + ". " + this._data[0];
		}
	}
}
